import { types } from 'mobx-state-tree';
var SidebarStore = function (sidebarKeys) { return types.model({
    activeSidebar: types.maybe(types.enumeration(sidebarKeys))
})
    .named('SidebarStore')
    .volatile(function (_self) { return ({
    activeParameters: undefined
}); })
    .views(function (self) { return ({
    get sidebarIsOpen() {
        return self.activeSidebar !== undefined;
    },
    isOpen: function (sidebarKey) {
        return self.activeSidebar === sidebarKey;
    },
    getActiveParameters: function (sidebarKey) {
        if (!this.isOpen(sidebarKey)) {
            return undefined;
        }
        return self.activeParameters;
    }
}); })
    .actions(function (self) { return ({
    openSidebar: function (sidebarKey, parameters) {
        self.activeSidebar = sidebarKey;
        self.activeParameters = parameters;
    },
    closeSidebar: function () {
        self.activeSidebar = undefined;
        self.activeParameters = undefined;
    },
    toggleSidebar: function (sidebarKey, parameters) {
        if (self.isOpen(sidebarKey)) {
            this.closeSidebar();
        }
        else {
            this.openSidebar(sidebarKey, parameters);
        }
    }
}); }); };
export default SidebarStore;
//# sourceMappingURL=SidebarStore.js.map